import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  TruncateText,
  typographyVariants,
} from '@mint-lib/tw-components';

import { FileAccessUser } from '../../../types/rag.js';

type Props = {
  user: FileAccessUser;
  label: string;
  endAdornment?: React.ReactNode;
};

const FileAccessUserRow = ({ user, label, endAdornment }: Props) => {
  return (
    <div className="flex h-8 items-center gap-2">
      <Avatar size="small">
        {user.avatar && <AvatarImage src={user.avatar} />}
        <AvatarFallback
          firstName={user.firstName}
          lastName={user.lastName}
          email={user.email}
        />
      </Avatar>
      <TruncateText>
        <span className={typographyVariants({ variant: 'bodyShort01' })}>
          {label}
        </span>
      </TruncateText>
      {endAdornment ? (
        <div className="ml-auto flex items-center">{endAdornment}</div>
      ) : null}
    </div>
  );
};

export { FileAccessUserRow };
